<template>
  <div class="w-full items-center">
    <div class="w-full lg:w-1/2 md:w-1/2">
      <div class="router-header flex flex-wrap items-center mb-3">
        <div class="content-area__heading pr-4 border-0">
          <!--<h4 class="mb-1">Coach Feedback</h4>-->
          <!--<div class="mt-2 mb-1">Select 3 or more to continue</div>-->
        </div>
      </div>
      <div v-if="traineeCoachId === null"><h1>{{ $t("coachingExperience.ce1") }}</h1></div>
      <div v-else-if="traineeCoachId != null && skillsCount ===0 "><h1>{{ $t("coachingExperience.ce22") }}</h1></div>

      <div
        v-else-if="goingGreat === false && notSoGood === false && skillsCount >0  && coachingSurveyDate ===null"
        class="text-center"
      >
        <div class="mb-base">
          <span class="text-center" style="font-size: 25px;">
           {{ $t("coachingExperience.ce20")}}
          </span>
        </div>
        <div class="text-center">
          <div class="mb-base">
            <vs-button size="large" color="primary" @click="goingGreatBtn"
              >{{ $t("coachingExperience.ce3") }}</vs-button
            >
          </div>
          <div class="mb-base">
            <vs-button size="large" color="danger" @click="notSoGoodBtn"
              >{{ $t("coachingExperience.ce4") }}</vs-button
            >
          </div>
        </div>
        <!--<div>
          <p class="text-center" @click="coachingExperiencePopup = false">
            Maybe Later
          </p>
        </div>-->
      </div>
      <div
        v-else-if="goingGreat === false && notSoGood === false && skillsCount >0  && coachingSurveyDate && coachingSurveyStatus===1 "
        class="text-center"
      >
        <h1>{{ $t("coachingExperience.ce23") }}</h1>
      </div>
      <div
        v-else-if="goingGreat === false && notSoGood === false && skillsCount >0  && coachingSurveyDate && coachingSurveyStatus===2 "
        class="text-center"
      >
        <div class="mb-base">
          <span class="text-center" style="font-size: 25px;">
            {{ $t("coachingExperience.ce2") }}  {{coachingOverdueCounter}}{{ $t("coachingExperience.ce19")}} <br>{{ $t("coachingExperience.ce20")}}
          </span>
        </div>
        <div class="text-center">
          <div class="mb-base">
            <vs-button size="large" color="primary" @click="goingGreatBtn"
            >{{ $t("coachingExperience.ce3") }}</vs-button
            >
          </div>
          <div class="mb-base">
            <vs-button size="large" color="danger" @click="notSoGoodBtn"
            >{{ $t("coachingExperience.ce4") }}</vs-button
            >
          </div>
        </div>
        <!--<div>
          <p class="text-center" @click="coachingExperiencePopup = false">
            Maybe Later
          </p>
        </div>-->
      </div>
      <div v-else-if="goingGreat === true && notSoGood === false">
        <div class="mb-base text-center">
          <span class="text-center" color="primary" style="font-size: 25px;">
            {{ $t("coachingExperience.ce5") }}
          </span>
        </div>
        <div class="mb-base">
          <span class="text-center" style="font-size: 15px;">
            {{ $t("coachingExperience.ce6") }}
          </span>
        </div>
        <div class="mb-base">
          <span class="text-center">
            {{ $t("coachingExperience.ce7") }} {{coachingSurveyDays}} {{ $t("coachingExperience.ce19") }}  {{ $t("coachingExperience.ce21") }}
          </span>
        </div>
      </div>
      <div v-else-if="goingGreat === false && notSoGood === true">
        <div class="items-left">
          <h4 class="mb-base">
            {{ $t("coachingExperience.ce8") }}
          </h4>
          <div>
          <div class="mb-base pb-1">
            <div>
              <span class="font-bold" color="primary" >
                {{ $t("coachingExperience.ce9") }} </span
              ><br />
              <span>{{ $t("coachingExperience.ce10") }}</span>
              <div class="mb-base">
                <vs-slider step="2" max="10" v-model="relationship" />
              </div>
              <!--<div v-if="$store.state.endorsementInvite.externalFeedback[responseStep - 1]" class="w-full text-center font-bold">
                {{$store.state.endorsementInvite.externalFeedback[responseStep - 1].currentGapText}}
              </div>
              <div v-else class="w-full text-center font-bold">
                SLIDE TO RATE
              </div>-->
            </div>
          </div>
          <div class="mb-base pb-1">
            <div>
              <span class="font-bold" color="primary" >
                {{ $t("coachingExperience.ce11") }} </span
              ><br />
              <span
                >{{ $t("coachingExperience.ce12") }}</span
              >
              <div class="mb-base">
                <vs-slider step="2" max="10" v-model="resourceAvailability" />
              </div>
              <!--<div v-if="$store.state.endorsementInvite.externalFeedback[responseStep - 1]" class="w-full text-center font-bold">
                {{$store.state.endorsementInvite.externalFeedback[responseStep - 1].currentGapText}}
              </div>
              <div v-else class="w-full text-center font-bold">
                SLIDE TO RATE
              </div>-->
            </div>
          </div>
          <div class="mb-base pb-1">
            <div>
              <span class="font-bold" color="primary" >
                {{ $t("coachingExperience.ce13") }} </span
              ><br />
              <span>{{ $t("coachingExperience.ce14") }}</span>
              <div class="mb-base">
                <vs-slider step="2" max="10" v-model="managerSupport" />
              </div>
              <!--<div v-if="$store.state.endorsementInvite.externalFeedback[responseStep - 1]" class="w-full text-center font-bold">
                {{$store.state.endorsementInvite.externalFeedback[responseStep - 1].currentGapText}}
              </div>
              <div v-else class="w-full text-center font-bold">
                SLIDE TO RATE
              </div>-->
            </div>
          </div>
          <div class="items-center">
            <div class="vx-col w-full footer-next">
              <div class="vx-card vx-card-next">
                <div class="vx-card__collapsible-content vs-con-loading__container">
                  <div class="vx-card__body">
                    <div class="vx-row">
                      <div class="vx-col w-full mb-2">
                        <vs-button
                          class="w-full lg:w-1/2 md:w-1/2"
                          :disabled="disabledSubmitBtn"
                          @click="submitCoachingExperience"
                        >{{ $t("coachingExperience.ce15") }}</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        </div>
      </div>
      <div v-else-if="coachingExperienceSaved">
      <div class="mb-base text-center">
        <span class="text-center" color="primary" style="font-size: 20px;">
          {{ $t("coachingExperience.ce16") }}
        </span>
      </div>
      <div class="mb-base text-center">
        <span class="text-center" style="font-size: 20px; color: #079E9A;">
          {{ $t("coachingExperience.ce17") }}
        </span>
      </div>
      <div class="mb-base text-center">
        <span class="text-center">
          {{ $t("coachingExperience.ce18") }}
        </span>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoachingExperience",
  data() {
    return {
      coachingExperiencePopup: true,
      goingGreat: false,
      notSoGood: false,
      skillsCount:null,
      SkillsProgressCount:null,
      coachingSurveyDate:"",
      coachingSurveyStatus:'',
      coachingOverdueCounter:'',
      relationship: 0,
      resourceAvailability: 0,
      managerSupport: 0,
      traineeCoachId: null,
      coachingSurveyDays:null,
      coachingExperienceSaved: false,
      source: null
    };
  },
  computed: {
    disabledSubmitBtn() {
      return (
        this.resourceAvailability === 0 ||
        this.managerSupport === 0
      );
    }
  },
  methods: {
    goingGreatBtn() {
      this.goingGreat = true;
      this.relationship = 10;
      this.resourceAvailability = 10;
      this.managerSupport = 10;
      this.source = "goingGreat";
      this.submitCoachingExperience();
    },
    notSoGoodBtn() {
      this.notSoGood = true;
      this.source = "notSoGood";
    },
    submitCoachingExperience() {
      const ceObj = {
        traineeCoachId: this.traineeCoachId,
        relationship: this.relationship,
        resourceAvailability: this.resourceAvailability,
        managerSupport: this.managerSupport
      };
      this.$store
        .dispatch("coachingExperience/saveCoachingExp", ceObj)
        .then(res => {
          let data= JSON.parse(localStorage.getItem('userInfo'));
          const query = {
            usersId: data.usersId,
            progressStatus:'in_progress'
          };
          this.$store
            .dispatch("addSkill/findCompetency", { query })
            .then(res => {
              let traineeCompetenciesId = [];
              for (let k = 0; k <res.data.length; k++) {
                traineeCompetenciesId.push(res.data[k].id);
              }
              for(let i = 0; i <traineeCompetenciesId.length; i++){
                     let dt =new Date();
                     let coachingSurveyDate = new Date(dt.setDate(dt.getDate() + this.coachingSurveyDays));
                const updateData = {
                  id:traineeCompetenciesId[i],
                  coachingSurveyDate: coachingSurveyDate
                };
                this.$store
                  .dispatch("endorsementInvite/markGoalComplete", updateData)
                  .then(res => {}).catch();
              }
              console.log("coach found", res);
            })
            .catch(err => {
              console.log("coach not found", err);
            });
          console.log("coaching experience saved", res);
          if (this.source === "notSoGood") {
            this.goingGreat = null;
            this.notSoGood = null;
            this.coachingExperienceSaved = true;
          } else {
            this.goingGreat = true;
            this.notSoGood = false;
          }
        })
        .catch(err => {
          console.log("could not save coaching experience", err);
        });
    }
  },
  created() {
    let data= JSON.parse(localStorage.getItem('userInfo'));
    const query = {
      traineeId: data.usersId
    };
    this.$store
      .dispatch("coachingExperience/fetchCoach", { query })
      .then(res => {
        console.log("coach found", res);
        this.coachingSurveyDays=res.data[0].userData[0].company[0]['coachingSurveyDays'];
        this.traineeCoachId = res.data[0].id;
      })
      .catch(err => {
        console.log("coach not found", err);
      });

    this.$store.dispatch('addSkill/findCompetency', {query: {usersId: data.usersId,progressStatus:'in_progress'}})
      .then(res => {
        console.log("Skills Data", res.data);
        if(res.data.length===0){
          this.skillsCount=0;
        }else{
         if(res.data[0].coachingSurveyDate===null && res.data[0].progressStatus==='in_progress'){
           this.coachingSurveyDate=res.data[0].coachingSurveyDate;
         }
         else if (res.data[0].coachingSurveyDate !=null && res.data[0].progressStatus==='in_progress'){
           if(new Date() < new  Date(res.data[0].coachingSurveyDate)){
             console.log('Completed');
             this.coachingSurveyDate=res.data[0].coachingSurveyDate;
                this.coachingSurveyStatus=1;// 1 for completed and 0 for initial stage
           }
           else if(new Date() > new Date(res.data[0].coachingSurveyDate)){
             console.log('Completed');
             this.coachingSurveyDate=res.data[0].coachingSurveyDate;
             const date1 = new Date(this.coachingSurveyDate);
             const date2 = new Date();
             const diffTime = Math.abs(date2 - date1);
             const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
             this.coachingOverdueCounter=diffDays;
             //console.log(diffTime + " milliseconds");
             console.log(diffDays + " days");
             this.coachingSurveyStatus=2; //2 for overdue
           }
         }
          this.skillsCount=res.data.length;
        }
      })
      .catch(err => {
        console.log("coach not found", err);
      });
  }
};
</script>

<style scoped>
.vx-card-next {
  margin-top: 2rem;
  /*border-radius: 0;*/
  box-shadow: none;
  -webkit-box-shadow: none;
}

.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}
.items-left {
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
@media (max-width: 767px) {
  .footer-next {
    position: fixed;
    bottom: 0;
    /*width: 100%;*/
    width: 100vw;
    left: calc(-50vw + 50%);
  }
}
</style>
